import { LinkifiedText } from '../../../LinkifiedText';

// A contact picked via "+ Contact" rides the outgoing message text as a `[Name]` token (see
// `lib/contact-references.ts` — the harness resolves it against `references.contacts`, so the WIRE
// text must keep the bracket form). In the sender's own bubble we render that token as a bold
// `@Name` mention — the same idiom the composer chip and the native `@ContactName` mention use —
// while everything around it keeps normal URL linkification.
//
// Deliberately narrow: a `[label](url)` markdown link target is left alone (mirrors the native
// guard in `ChatText.swift`), so a pasted link never renders as a stray mention.
const CONTACT_TOKEN = /\[([^[\]\n]+)\]/g;

export function ContactMentionText({ text }: { text: string }) {
  const parts: React.ReactNode[] = [];
  let last = 0;
  let key = 0;
  let match: RegExpExecArray | null;
  CONTACT_TOKEN.lastIndex = 0;
  while ((match = CONTACT_TOKEN.exec(text)) !== null) {
    const after = text[match.index + match[0].length];
    // A markdown link `[label](url)` — not a contact token. Leave it to the linkifier.
    if (after === '(') continue;
    if (match.index > last) {
      parts.push(<LinkifiedText key={key++} text={text.slice(last, match.index)} />);
    }
    parts.push(
      <strong key={key++} style={{ fontWeight: 700, textDecoration: 'underline', textUnderlineOffset: 2 }}>
        @{match[1]}
      </strong>,
    );
    last = match.index + match[0].length;
  }
  if (parts.length === 0) return <LinkifiedText text={text} />;
  if (last < text.length) parts.push(<LinkifiedText key={key++} text={text.slice(last)} />);
  return <>{parts}</>;
}
